import React from "react";
import classes from "./dashboardlocation.module.css";
import {
  Card,
  CardContent,
  Avatar,
  Badge,
  Chip,
  Typography,
  Button,
} from "@mui/material";
import {
  checkOnline,
  generateColor,
  getChipColor,
  stringAvatar,
  formatStatusLabel,
} from "../../../utilities/commonFunctions";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { LOCATION } from "../../../api-calls/api-urls";

const DashboardLocationCard = ({
  item,
  index,
  ln,
  setUpdateState,
}) => {
  const navigate = useNavigate();


  const handleViewRoute = (event, item) => {
    event.stopPropagation(); // Prevent card click event from firing
    navigate(`/maps/location-view-route/${item.slug.toLowerCase()}`);
  };

  const handleNotReached = async (event, item) => {
    event.stopPropagation(); // Prevent card click event from firing
    const { data } = await authApi.put(
      `${LOCATION}/mark-not-reached/${item._id}`,
      {},
      {
        headers: { Authorization: getAuthorizationHeader() },
      }
    );
    console.log(data);
    setUpdateState(data);
  };


  // useEffect(() => {
  //   checkOnline( item?.teamMember?._id);
  // }, [teamMembersList, item]);

  return (
    <div key={index}>
      <Card
        key={index}
        className={classes.teamCard}
        // onClick={(e) => handleCardClick(e, item)}
      >
        <CardContent
          sx={{ paddingBottom: "16px !important" }}
          className={classes.teamCardContent}
        >
          <div className={classes.locationGridCardHeader}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
              }}
            >
              <Badge
                color={
                  checkOnline(item?.teamMember?._id) === "checkin"
                    ? "success"
                    : "error"
                }
                badgeContent=" "
                // variant="dot"
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                className={classes.LocationOnlineBadge}
                sx={{
                  ".MuiBadge-dot": {
                    width: "10px", // Adjust width
                    height: "10pxLocationOnlineBadge", // Adjust height
                  },
                }}
              >
                {item?.teamMember &&
                item?.teamMember?.profile_pic &&
                item?.teamMember?.profile_pic?.filename ? (
                  <Avatar
                    alt={item.teamMember.name?.trim() || item.title}
                    src={`${process.env.REACT_APP_IMAGE_URL}/${item?.teamMember?.profile_pic?.destination}${item?.teamMember?.profile_pic?.filename}`}
                    sx={{ width: 44, height: 44,textTransform:"uppercase" }}
                  />
                ) : (
                  <Avatar
                    {...stringAvatar(
                      item.teamMember.name?.trim() || item.title
                    )}
                    sx={{
                      bgcolor: item.department_details?.[0]?.colour
                        ? item.department_details[0].colour
                        : `${generateColor(
                            item.teamMember.name || item.title
                          )}`,
                      width: "44px",
                      height: "44px",
                      textTransform:"uppercase"
                    }}
                  />
                )}
              </Badge>

              <div className={classes.memberCardText}>
                <Typography className={classes.memberCardTextHeading}>
                  {item.title}
                </Typography>
              </div>
            </div>

            {/* <Chip
              className={classes.locationStatusChip}
              label={item.status}
              size="small"
              // style={getChipColor(item.status)}
            /> */}
            <div
              onClick={(event) => handleViewRoute(event, item)}
              style={{ fontSize: "14px", color: "#1273B8" }}
            >
              {ln.view_route}
            </div>
          </div>
          <hr className={classes.UnderlineHr} />
          <div className={classes.memberCardTextContainer}>
            <div className={classes.DashboardLocationCard_left}>
              <div className={classes.DashboardLocationCard_left_inner}>
                <Typography className={classes.form_lable}>
                  {ln.team_member}
                </Typography>

                {/* {item.status === "rejected" ? (
                  <div>
                    <Typography className={classes.form_lable}>
                      {ln.rejected_reason}
                    </Typography>
                    <Typography className={classes.memberCardTextHeading}>
                      {item?.user_location?.rejection_notes?.length > 11
                        ? `${item?.user_location?.rejection_notes.substring(
                            0,
                            11
                          )}...`
                        : item?.user_location?.rejection_notes}
                    </Typography>
                  </div>
                ) : null} */}
                <Typography className={classes.form_lable}>
                  {ln.assigned_on}
                </Typography>

                <Typography className={classes.form_lable}>
                  {ln.time}
                </Typography>
              </div>
              <div className={classes.DashboardLocationCard_left_inner}>
                <Typography className={classes.memberCardTextHeading}>
                  {item.teamMember.name}
                </Typography>
                <Typography className={classes.memberCardTextHeading}>
                  {moment(item.assigned_on).format("DD MMM YYYY")}
                </Typography>
                <Typography className={classes.memberCardTextHeading}>
                  {moment(item.assigned_on).format("hh:mm A")}
                </Typography>
              </div>
            </div>
            <div className={classes.memberCardText_new}>
              <div
                className={classes.DashboardLocationCard_left}
                style={{ gap: "46px" }}
              >
                <div className={classes.DashboardLocationCard_left_inner}>
                  <Typography className={classes.form_lable}>
                    {ln.status}
                  </Typography>

                  {item.status === "rejected" ? (
                    <Typography className={classes.form_lable}>
                      {ln.rejected_reason}
                    </Typography>
                  ) : null}
                </div>
                <div className={classes.DashboardLocationCard_left_inner}>
                  <Chip
                    className={classes.locationStatusChip}
                    label={formatStatusLabel(item.status)}
                    size="small"
                    style={getChipColor(item.status)}
                  />
                  {item.status === "rejected" ? (
                    <Typography className={classes.memberCardTextHeading}>
                      {item?.user_location?.rejection_notes?.length > 11
                        ? `${item?.user_location?.rejection_notes.substring(
                            0,
                            11
                          )}...`
                        : item?.user_location?.rejection_notes}
                    </Typography>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          {item.status === "completed" ? (
            <>
              <hr className={classes.UnderlineHr} />
              <div className={classes.memberCardBtnSection}>
                {item.status === "completed" ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      size="small"
                      style={{
                        width: "45%",
                        height: "40px",
                      }}
                      className={classes.locationCardButton}
                      onClick={(event) => handleNotReached(event, item)}
                    >
                      {ln.not_reached}?
                    </Button>
                  </div>
                ) : null}
              </div>
            </>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardLocationCard;
